module.exports = __webpack_public_path__ + "static/img/noperson.cad20856.png";